<template>
  <div class="p-6">
    <h1 class="text-2xl font-bold mb-4 text-[#f94368]">Gerenciar Planos</h1>

    <!-- Formulário -->
    <div class="bg-white rounded-md shadow p-4 mb-6 max-w-5xl mx-auto">
  <h2 class="text-lg font-semibold mb-3">{{ editando ? 'Editar Plano' : 'Novo Plano' }}</h2>

  <!-- Seção 1 -->
  <div class="grid grid-cols-1 md:grid-cols-1 gap-4 mb-4">
    <div>
      <label class="text-sm font-medium text-gray-700">Nome</label>
      <input v-model="form.nome" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Descrição</label>
      <input v-model="form.descricao" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Tecnologia</label>
      <input v-model="form.tecnologia" class="input" />
    </div>
  </div>

  <!-- Seção 2 -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
    <div>
      <label class="text-sm font-medium text-gray-700">Valor</label>
      <input v-model="form.valor" type="number" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Processamento</label>
      <input v-model="form.processamento" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">RAM 1</label>
      <input v-model="form.ram1" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">RAM 2</label>
      <input v-model="form.ram2" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Disco</label>
      <input v-model="form.disco" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Banco de Dados</label>
      <input v-model="form.banco" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Domínios</label>
      <input v-model="form.dominios" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Subdomínios</label>
      <input v-model="form.subdominios" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">E-mails</label>
      <input v-model="form.emails" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Quantidade de Apps</label>
      <input v-model="form.app" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Tipo de Plano</label>
      <select v-model="form.planoTipo" class="input">
        <option disabled value="">Selecione o tipo de plano</option>
        <option value="PHP">PHP</option>
        <option value="NODEJS">NODEJS</option>
        <option value="JAVA">JAVA</option>
        <option value="SPRING">SPRING</option>
        <option value="VPSLINUX">VPS LINUX</option>
        <option value="VPSICP">VPS ICP</option>
        <option value="VPSCPANEL">VPS CPANEL</option>
        <option value="DEDICADO">DEDICADO</option>
        <option value="REVENDAPHP">REVENDA PHP</option>
        <option value="PROMOCIONAL-DEDICADO">PROMOCIONAL-DEDICADO</option>
        <option value="PROMOCIONAL-HOSPEDAGEM-PHP">PROMOCIONAL-HOSPEDAGEM-PHP</option>
        <option value="PROMOCIONAL-HOSPEDAGEM-REVENDA">PROMOCIONAL-HOSPEDAGEM-REVENDA</option>
        <option value="PROMOCIONAL-HOSPEDAGEM-JAVA">PROMOCIONAL-HOSPEDAGEM-JAVA</option>
        <option value="PROMOCIONAL-HOSPEDAGEM-NODE">PROMOCIONAL-HOSPEDAGEM-NODE</option>
        <option value="PROMOCIONAL-HOSPEDAGEM-SPRING">PROMOCIONAL-HOSPEDAGEM-SPRING</option>
        <option value="PROMOCIONAL-VPS-ICP">PROMOCIONAL-VPS-ICP</option>
        <option value="PROMOCIONAL-VPS-CPANEL">PROMOCIONAL-VPS-CPANEL</option>
        <option value="PROMOCIONAL-VPS-LINUX">PROMOCIONAL-VPS-LINUX</option>
      </select>
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Ordem</label>
      <input v-model.number="form.ordem" type="number" class="input" />
    </div>
  </div>

  <!-- Seção 3 -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
    <div>
      <label class="text-sm font-medium text-gray-700">Desconto Período 1</label>
      <input v-model.number="form.desconto1" type="number" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Desconto Período 2</label>
      <input v-model.number="form.desconto2" type="number" class="input" />
    </div>
    <div>
      <label class="text-sm font-medium text-gray-700">Desconto Período 3</label>
      <input v-model.number="form.desconto3" type="number" class="input" />
    </div>
  </div>

  <!-- Checkboxes -->
  <div class="grid grid-cols-1 md:grid-cols-1 gap-4 mb-4">
    <label class="flex items-center space-x-2">
      <input type="checkbox" v-model="form.ativo" class="form-checkbox" />
      <span class="text-sm">Plano Ativo</span>
    </label>
    <label class="flex items-center space-x-2">
      <input type="checkbox" v-model="form.promocional" class="form-checkbox" />
      <span class="text-sm">Destaque Promoção</span>
    </label>
  </div>

  <!-- Botões -->
  <div class="flex gap-4">
    <button @click="salvarPlano" class="bg-[#f94368] text-white px-4 py-2 rounded">
      {{ editando ? 'Atualizar' : 'Criar' }}
    </button>
    <button v-if="editando" @click="cancelarEdicao" class="text-sm text-gray-500">Cancelar</button>
  </div>
</div>


    <!-- Lista -->
    <div class="bg-white rounded-md shadow p-4">
      <table class="w-full text-sm">
        <thead class="border-b bg-gray-50">
          <tr>
            <th class="text-left p-2 text-center">Nome</th>
            <th class="text-left p-2 text-center">Valor</th>
            <th class="text-left p-2 text-center">Tipo</th>
            <th class="text-left p-2 text-center">Ativo</th>
            <th class="text-left p-2 text-center">Destaque Promoção</th>
            <th class="text-left p-2 text-center">Ordem</th>
            <th class="text-left p-2  ext-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="plano in planos"
            :key="plano.id"
            class="border-b hover:bg-gray-200 transition-colors duration-150"
          >            
            <td class="p-2 text-center">{{ plano.nome }}</td>
            <td class="p-2 text-center">R$ {{ plano.valor?.toFixed(2).replace('.', ',') }}</td>
            <td class="p-2 text-center">{{ plano.planoTipo }}</td>
            <td class="p-2 text-center">
              <span
                :class="plano.ativo ? 'text-green-600 font-semibold' : 'text-gray-400 italic'"
              >
                {{ plano.ativo ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td class="p-2 text-center">
              <span
                :class="plano.promocional ? 'text-green-600 font-semibold' : 'text-gray-400 italic'"
              >
                {{ plano.promocional ? 'Sim' : 'Não' }}
              </span>
            </td>

            <td class="p-2 text-center">{{ plano.ordem }}</td>
            <td class="p-2 ">
              <button @click="editarPlano(plano)" class="text-blue-500 mr-2">Editar</button>
              <button @click="deletarPlano(plano.id)" class="text-red-500">Excluir</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import api from '@/admin/services/api'

const planos = ref([])
const editando = ref(false)
const planoEditandoId = ref(null)

const form = ref({
  nome: '', descricao: '', valor: '', processamento: '', ram1: '', ram2: '',
  tecnologia: '', disco: '', banco: '', dominios: '', subdominios: '',
  emails: '', planoTipo: '', app: '', ativo: true, ordem: 0
})

const carregarPlanos = async () => {
  const { data } = await api.get('/api/planos/listarativos')
  planos.value = data.sort((a, b) => a.planoTipo.localeCompare(b.planoTipo))

}

const salvarPlano = async () => {
  try {
    if (editando.value) {
      await api.put(`/api/planos/${planoEditandoId.value}`, form.value)
    } else {
      await api.post('/api/planos', form.value)
    }
    await carregarPlanos()
    limparFormulario()
  } catch (e) {
    console.error('Erro ao salvar plano:', e)
  }
}

const editarPlano = (plano) => {
  form.value = { ...plano }
  planoEditandoId.value = plano.id
  editando.value = true
}

const deletarPlano = async (id) => {
  if (confirm('Tem certeza que deseja excluir este plano?')) {
    await api.delete(`/api/planos/${id}`)
    await carregarPlanos()
  }
}

const cancelarEdicao = () => {
  limparFormulario()
}

const limparFormulario = () => {
  form.value = {
    nome: '', descricao: '', valor: '', processamento: '', ram1: '', ram2: '',
    tecnologia: '', disco: '', banco: '', dominios: '', subdominios: '',
    emails: '', planoTipo: '', app: '', ativo: true, ordem: 0
  }
  editando.value = false
  planoEditandoId.value = null
}

onMounted(() => {
  carregarPlanos()
})
</script>

<style scoped>
.input {
  @apply border border-gray-300 rounded px-3 py-2 w-full;
}
</style>
